import { SVGProps, Ref, forwardRef } from 'react';

export const MagnifierFilledHeartOutlinedSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <g>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M14.359.07C15.292.309 16 1.142 16 2.244c0 .973-.66 1.739-1.298 2.286-.617.531-1.378.993-1.983 1.36l-.485.296-.485-.295c-.605-.368-1.365-.83-1.983-1.36-.637-.548-1.298-1.314-1.298-2.287 0-1.101.708-1.934 1.641-2.174.713-.182 1.487-.007 2.125.526.639-.533 1.412-.709 2.125-.526m-.347 1.356c-.309-.079-.79.005-1.202.602l-.576.834-.576-.834c-.412-.597-.893-.68-1.201-.601-.321.082-.589.362-.589.817 0 .322.233.729.81 1.224.453.39 1.01.744 1.556 1.078.546-.334 1.103-.689 1.556-1.078.577-.495.81-.902.81-1.224 0-.456-.268-.736-.588-.818"
                        fill="currentColor"
                    />
                    <path
                        d="M7.068 2.244c0-.64.154-1.232.426-1.745L7.246.497c-5.062 0-6.75 3.375-6.75 6.75s1.688 6.75 6.75 6.75c1.953 0 3.403-.502 4.448-1.313L14.51 15.5l.99-.99-2.822-2.822c.939-1.24 1.318-2.84 1.318-4.441q0-.246-.012-.49-.272.17-.503.309l-1.247.758-1.246-.758c-.586-.356-1.429-.867-2.135-1.474-.695-.598-1.785-1.724-1.785-3.348"
                        fill="currentColor"
                    />
                </g>
            </g>
        </svg>
    )
);
MagnifierFilledHeartOutlinedSize16Glyph.displayName = 'MagnifierFilledHeartOutlinedSize16Glyph';
